import { useSelector } from "react-redux";
import IconComponent from "@CubeComponents/icons";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { RootState } from "@Reducers/index";
import { useTranslation } from "@i18n";
import type { TranslationKey } from "@i18n";

interface RightSidebarFileExpProps {
  /** FileVersion's accordion switch; the `action` strings below are its cases. */
  handleAccordionStateUpdate: (type: string) => void;
}

function RightSidebarFileExp({ handleAccordionStateUpdate }: Readonly<RightSidebarFileExpProps>) {
  const layout = useSelector((state: RootState) => state.layout);
  const { t } = useTranslation();

  // Every label below is a translation key that exists in en.json, so the tooltip gets a real
  // `TranslatedString` out of `t()` instead of a plain string asserted into the brand.
  const iconButton = (action: string, name: string, toolTipContent: TranslationKey) => (
    <ButtonComponent
      className="mt-6 cursor-pointer bg-transparent border-none p-0 focus:outline-none"
      buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
      onClick={() => handleAccordionStateUpdate(action)}
      data-testid="footerAcknowledgeBtn"
    >
      <IconComponent name={name} toolTipContent={t(toolTipContent)} width="1.5rem" height="1.5rem" />
    </ButtonComponent>
  );

  return (
    <div className="px-3 flex flex-col justify-start items-center bg-surface_white">
      {iconButton("openDetails", "details", "Details")}
      {iconButton("openCustomMetadata", "CustomMetadata", "Templates")}
      {iconButton("openAccess", "access", "Access")}
      {iconButton("openSharing", "Transmittals", "Transmittals")}
      {iconButton("openVersion", "VersionsIcon", "Versions")}
      {iconButton("openDependency", "DependenciesIcon", "Dependencies")}
      {layout.FILE_PROPERTIES?.REVISION?.ENABLE && iconButton("openRevision", "RevisionsIcon", "Revisions")}
    </div>
  );
}

export default RightSidebarFileExp;
